import { render, staticRenderFns } from "./CreateEditContaModal.vue?vue&type=template&id=6d213760&"
import script from "./CreateEditContaModal.vue?vue&type=script&lang=js&"
export * from "./CreateEditContaModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports